module.exports = __webpack_public_path__ + "static/LiuJianMaoCao-Regular-39b21cb33d1e6cdf231a1555828b2a11.ttf";